<template>
  <v-card class="mb-3" style="border-radius: 10px;">
    <v-layout row wrap>
      <v-flex xs12>
        <v-data-table
          :headers="internal_bank_account_headers"
          :headers-length="6"
          :items="local_bank_accounts"
          :key="refresh_count"
          class="elevation-0 mt-2 mb-2 mx-3 light-regular-font"
          :no-data-text="i18n('Nenhum canal bancário registrado')"
          hide-actions
        >
          <template v-slot:items="props">
            <td>{{ props.item.id }}</td>
            <td class="text-xs-center">{{ props.item.currency }}</td>
            <td v-if="show_branch_country" class="text-xs-center">{{ props.item.branch_country }}</td>
            <td class="text-xs-center">{{ props.item.flow_type }}</td>
            <td class="text-xs-center">{{ props.item.credit_transactions || '0' }} / {{ props.item.credit_value || '0.00' }}</td>
            <td class="text-xs-center">{{ props.item.debit_transactions || '0' }} / {{ props.item.debit_value || '0.00' }}</td>
            <td class="text-xs-center">{{ props.item.balance || '0.00' }}</td>
            <td class="text-xs-center" v-if="admin">
              <v-icon small @click="setDownloadStatementDialog(props.item)" style="max-width: 35px;">download</v-icon>
              <v-btn icon>
                <v-icon
                  small
                  @click="toggleFavoriteAccount(props)"
                  style="max-width: 35px;"
                >{{props.item.is_favorited ? 'star' : 'star_border'}}</v-icon>
              </v-btn>
            </td>
          </template>
        </v-data-table>
        <statement-download-dialog :record="selectedBankAccount" :dialog="download_dialog" @closeDialog="closeDialog" />
        <v-snackbar
          v-model="snackbar_show"
          :color="snackbar_color"
          :timeout="3000"
        >
          {{snackbar_text}}
        </v-snackbar>
      </v-flex>
    </v-layout>
    <v-card-actions>
      <v-layout column>
        <v-flex xs12>
          <v-btn v-if="show_more_button" block dark class="ma-0 btn-style" @click="requestMoreRecords">
            {{i18n('Exibir mais')}}
          </v-btn>
        </v-flex>
      </v-layout>
    </v-card-actions>
  </v-card>
</template>

<script>
import StatementDownloadDialog from "./components/dialogs/StatementDownloadDialog.vue";
import utils from "./shared/Utils"
export default {
  name: 'InternalBankAccounts',
  components: {
    StatementDownloadDialog
  },
  props: {
    bank_accounts: {
      type: Array,
      default: []
    },
    show_branch_country: {
      type: Boolean,
      default: false
    },
    show_more_button: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      loaded: '',
      admin: false,
      local_bank_accounts: [],
      fav_accounts: [],
      refresh_count: 0,
      snackbar_text: '',
      snackbar_show: false,
      snackbar_color: 'blue',
      download_dialog: false,
      selectedBankAccount: {},
      internal_bank_account_headers: [
        { text: this.i18n('ID'), value: 'id', align: 'left', sortable: false },
        { text: this.i18n('Moeda'), value: 'currency', align: 'center', sortable: true },
        { text: this.i18n('Fluxo'), value: 'flow_type', align: 'center', sortable: true },
        { text: this.i18n('Créditos (transações/total)'), value: 'balance', align: 'center', sortable: false },
        { text: this.i18n('Débitos (transações/total)'), value: 'balance', align: 'center', sortable: false },
        { text: this.i18n('Saldo'), value: 'balance', align: 'center', sortable: false },
        { text: this.i18n('Ações'), value: 'actions', align: 'center', sortable: false },
      ]
    }
  },
  methods: {
    requestMoreRecords() {
      this.$emit('requestMoreRecords')
    },
    i18n(str) {
      return this.$root.l(str)
    },
    localeCurrency(value, currency) {
      return this.$root.localeCurrency(value, currency)
    },
    loadBalances() {
      let successCallbackFor = (context) => {
        return function(response) {
          if (response.body.data) {
            const index = context.bank_accounts.findIndex(el => el.id === context.id)
            let bank_account = context.bank_accounts[index]
            bank_account.balance = context.localeCurrency(response.body.data.balance, bank_account.currency)
            bank_account.credit_transactions = response.body.data.credit_transactions
            bank_account.debit_transactions = response.body.data.debit_transactions
            bank_account.credit_value = context.localeCurrency(response.body.data.credit_value, bank_account.currency)
            bank_account.debit_value = context.localeCurrency(response.body.data.debit_value, bank_account.currency)
            bank_account.is_favorited = this.fav_accounts.findIndex(el => el.bank_account_id == context.id) >= 0
            context.bank_accounts.splice(index, 1, bank_account)
          } else {
            console.log(response)
          }
        }
      }

      let errorCallbackFor = (context) => {
        return function(response) {
          console.log(response)
        }
      }

      const token = this.$cookies.get('api_token')
      const bank_accounts = this.local_bank_accounts
      const localeCurrency = this.localeCurrency

      bank_accounts.forEach(bank_account => {
        const url = this.admin ? `${this.$root.urls.admin__bank_accounts_new}${bank_account.id}/balance` : `${this.$root.urls.bank_accounts}${bank_account.id}/balance`
        const id = bank_account.id
        const context = {id, bank_accounts, localeCurrency}
        this.$http.get(url, { headers: { Authorization: `Bearer ${token}` }}).then(successCallbackFor(context), errorCallbackFor(context))
      })
    },
    toggleFavoriteAccount(props) {
      const bank_account = props.item
      const item_is_favorited = bank_account.is_favorited

      if (item_is_favorited) { this.removeAccountFromFavorites(bank_account.id) }
      else this.addToUserFavorites(bank_account.id)

      this.local_bank_accounts[props.index].is_favorited = !item_is_favorited
      this.refresh_count += 1
    },
    loadFavoriteAccounts() {
      let successCallbackFor = () => {
        return function(response) {
          if (response.body.data) {
            this.fav_accounts = response.body.data
            this.loadBalances()
          } else {
            console.log(response)
          }
        }
      }

      let errorCallbackFor = () => {
        return function(response) {
          console.log(response)
        }
      }

      const token = this.$cookies.get('api_token')
      const url = this.$root.urls.admin__user_favorites
      this.$http.get(url, { headers: { Authorization: `Bearer ${token}` }}).then(successCallbackFor(), errorCallbackFor())
    },
    addToUserFavorites(bank_account_id) {
      let successCallback = () => {
        this.snackbar_show = true
        return function(response) {
          if (response.body.data) {
            this.snackbar_text = 'Conta adicionada às favoritas.'
            this.snackbar_color = 'blue'
          } else {
            console.log(response)
          }
        }
      }

      let errorCallback = () => {
        return function() {
          this.snackbar_color = 'red'
          this.snackbar_text = 'Erro. Provavelmente a conta já está inserida.'
        }
      }
      const url = this.$root.urls.admin__user_favorites
      const token = this.$cookies.get('api_token')
      const payload = {bank_account_id: bank_account_id}
      this.$http.post(url, payload, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback(), errorCallback())

    },
    removeAccountFromFavorites(bank_account_id) {
      let successCallback = () => {
        this.snackbar_show = true
        return function(response) {
          if (response.body.data) {
            this.snackbar_text = 'Conta excluída da lista.'
            this.snackbar_color = 'blue'
          } else {
            console.log(response)
          }
        }
      }

      let errorCallback = () => {
        return function() {
          this.snackbar_color = 'red'
          this.snackbar_text = 'Erro. Provavelmente a conta já foi excluída'
        }
      }

      const url = `${this.$root.urls.admin__user_favorites}${bank_account_id}`
      const token = this.$cookies.get('api_token')
      this.$http.delete(url, { headers: { Authorization: `Bearer ${token}` }}).then(successCallback(), errorCallback())
    },
    setDownloadStatementDialog(bank_account) {
      this.selectedBankAccount = bank_account
      this.download_dialog = true;
    },
    closeDialog() {
      this.download_dialog = false
    },
    flowType(value) {
      if (value == 'cash_in') return this.i18n('entrada')
      if (value == 'cash_out') return this.i18n('saída')
      return this.i18n('entrada / saída')
    },
  },
  computed: {
    internal_bank_accounts() {
      return this.bank_accounts.map( item => {
        let branch_country = item.branch_country
        
        if (this.show_branch_country) {
          if (item.branch_country == 'CLP') {
            branch_country = 'Chile'
          } 
          else {
            branch_country = utils.parseBranchCountry(item.branch_country)
          }
        }

        return {...item, branch_country, flow_type: this.flowType(item.flow_type)}
      })
    }
  },
  mounted() {
    this.local_bank_accounts = this.internal_bank_accounts
    this.admin = this.$cookies.isKey('admin') && this.$cookies.get('admin') === 'true'
    this.admin && this.loadFavoriteAccounts()
    this.admin || this.loadBalances()
    !this.admin && this.internal_bank_account_headers.splice(6, 1)

    if(this.show_branch_country) {
      this.internal_bank_account_headers.splice(2, 0, { text: this.i18n('País'), value: 'branch_country', align: 'center', sortable: true })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/InternalBankAccounts.vue